import Sprite from './Sprite.js';
import PokemonPreview from './PokemonPreview.js';
import PauseMenuUI from './PauseMenuUI.js';
import TrainerCard from './TrainerCard.js';
import PokemonMenu from './PokemonMenu.js';
import OptionsBox from './OptionsBox.js';
import PokemonSummary from './PokemonSummary.js';
import NewMoveMenu from './NewMoveMenu.js';
import BagMenu from './BagMenu.js';
import DarkScreen from './DarkScreen.js';
import MartOptionsMenu from './MartOptionsMenu.js';
import MartItemsMenu from './MartItemsMenu.js';
import PokedexMenu from './PokedexMenu.js';
import PCMenu from './PCMenu.js';
import FlashScreen from './FlashScreen.js';
import TimeOfDayShader from './TimeOfDayShader.js';
import TownMapMenu from './TownMapMenu.js';

import { KPI_E, KPI_P, availableMaps, globalPokemonDataStore } from '../OverworldAnimation.js';
import MartItemAmountBox from './MartItemAmountBox.js';
import { imageStore } from '../images.js';
import WaterEntryZone from '../entities/WaterEntryZone.js';
import LandEntryZone from '../entities/LandEntryZone.js';

import { getOSM } from '../OverworldAnimation.js';
import LocationBanner from './LocationBanner.js';
import KeyboardMenuUI from './KeyboardMenuUI.js';
import SaveFileMenuUI from './SaveFileMenuUI.js';
import YesOrNoMenuUI from './YesOrNoMenuUI.js';
import OptionsMenuUI from './OptionsMenuUI.js';
import PixelText from './PixelText.js';
import SpeakerLabel from './SpeakerLabel.js';
import {
    NEW_UNAUTHORIZED_SESSION_STARTED,
    VERIFY_ACCESS_CODE,
    SET_ACCESS_CODE,
    MOVING,
    SET_NICKNAME,
    SAVE_FILE_SELECT,
    INTRO_CREDITS,
    SAVE_FILE_INCOMPATIBLE,
    NEW_FILE_STARTED,
    USE_KEYBOARD,
    SET_PLAYER_NAME,
    WARP_TO_LOCATION,
    CHANGE_DIRECTION,
    READ_TEXT_SOURCE,
    BOOT_UP_PC,
    MANAGE_POKEMON,
    CANT_LEAVE_PC_WITHOUT_POKEMON,
    MANAGE_POKEMON_WITH_SELECTED,
    PC_POKEMON_PRESELECTED,
    RELEASE_POKEMON,
    SHUT_DOWN_PC,
    INTERACT_WITH_MART_LOCATION,
    CHOOSE_MART_OPTION,
    BUY_FROM_MART,
    MART_OPTION_PRESELECTED,
    MART_OPTION_SELECT_AMOUNT,
    MART_ITEM_AMOUNT_SELECTED,
    MART_ITEM_AMOUNT_CONFIRMED,
    SELL_TO_MART,
    CANT_SELL_THIS_ITEM,
    MART_SELL_AMOUNT,
    MART_SELL_AMOUNT_CONFIRMATION,
    MART_ITEMS_SOLD,
    END_MART_INTERACTION,
    INTERACT_WITH_HEALING_LOCATION,
    INTERACT_WITH_HM_TREE,
    INTERACT_WITH_HM_ROCK,
    ACQUIRE_OVERWORLD_ITEM,
    START_BATTLE,
    START_TRAINER_BATTLE,
    BATTLE,
    END_BATTLE,
    EVOLVE_POKEMON,
    PAUSE_MENU,
    OPTIONS_MENU,
    POKEDEX,
    TRAINER_CARD,
    POKEMON,
    SWITCH_POSITIONS_WITH_WHO,
    POKEMON_SWITCH_POSITIONS,
    POKEMON_PRESELECTED,
    DO_WHAT_WITH_ITEM,
    POKEMON_SUMMARY,
    POKEMON_MOVE_DETAIL,
    BAG,
    BAG_ITEM_PRESELECTED,
    KEY_ITEM_PRESELECTED,
    USE_KEY_ITEM,
    TOWN_MAP,
    TOWN_MAP_LOCATION_DETAIL,
    CANT_USE_ITEM,
    SELECT_ITEM_RECIPIENT,
    ITEM_GIVEN_TO_POKEMON,
    ITEM_TAKEN_FROM_POKEMON,
    SELECT_ITEM_CONSUMER,
    SELECT_ITEM_CONSUMER_MOVE,
    APPLY_ITEM_TO_MOVE,
    APPLY_ITEM_TO_RECIPIENT,
    APPLY_EV_ITEM_TO_RECIPIENT,
    APPLY_RARE_CANDY,
    RARE_CANDY_APPLIED,
    MOVE_ITEM_APPLIED,
    HEALTH_ITEM_APPLIED,
    EV_ITEM_APPLIED,
    IT_WONT_HAVE_ANY_EFFECT,
    APPLY_HM_TO_RECIPIENT,
    NEW_MOVE_AVAILABLE,
    CONFIRM_LEARN_NEW_MOVE,
    CHOOSE_MOVE_TO_FORGET,
    FORGOT_MOVE,
    LEARNED_NEW_MOVE,
    STOP_LEARNING_NEW_MOVE,
    DID_NOT_LEARN_NEW_MOVE,
    SEEN_BY_TRAINER,
    APPROACHED_BY_TRAINER,
    USE_FLASH,
    OVERWORLD_EVENT,
    LEVEL_UP_POKEMON,
    UP,
    DOWN,
    LEFT,
    RIGHT,
    SELECT_PLAYER_GENDER,
} from '../constants.js';

import { canvas, c as ctx, keys } from '../setup.js';
import PlayerGenderMenuUI from './PlayerGenderMenuUI.js';
import NPCShadow from './NPCShadow.js';
export default class OverworldGUI {
    constructor({ stateMachine }) {
        // this.testPixelText = new PixelText({ text: 'Hello world! How are you?', position: { x: 16, y: 16 } });
        this.stateMachine = stateMachine;
        this.stateMachine.GUI = this;
        this.p1 = 0;
        this.p2 = 0;
        this.currentFPS = 0;
        this.performance = 0;
        this.layerRenderCount = 0;
        this.performanceSnapshot = 0;
        this.debugHighlight = null;
        this._initDebugClickListener();
        this.fpsText = new PixelText({
            text: `FPS: ${this.currentFPS} Perf: ${this.performanceSnapshot}`,
            position: {
                x: 16,
                y: 16,
            },
            color: 'white',
        });
        this.sprites = {};
        this.sprites.overworldTextBox = new Sprite({
            position: {
                x: 0,
                y: 112,
            },
            image: imageStore.get('img/overworld_text_box_new.png'),
            visible: false,
            moving: false,
        });
        this.overworldText = new PixelText({
            text: '',
            color: PixelText.blackTextColor,
            shadowColor: PixelText.whiteShadowColor,
            fontType: 'large',
            position: {
                x: 12,
                y: 112 + 10,
            },
            maxWidth: 200,
            cursor: 0,
            useCursor: true,
            canScroll: true,
            includeBounds: true,
        });
        this.speakerLabel = new SpeakerLabel();

        this.sprites.introBackground = new Sprite({
            position: { x: 0, y: 0 },
            image: imageStore.get('img/intro_screen.png'),
            visible: true,
        });

        this.sprites.introCreditsBackground = new Sprite({
            position: { x: 0, y: 0 },
            image: imageStore.get('img/intro_credits.png'),
            visible: true,
        });

        this.sprites.playerShadow = new NPCShadow({});
        this.sprites.player = this.stateMachine.player.overworldSprite;

        // Load foreground and background sources
        const backgroundImages = [];
        const foregroundImages = [];
        this.stateMachine.currentMap.backgroundSources.forEach((bgSource) => {
            const bgImage = imageStore.get(bgSource);
            backgroundImages.push(bgImage);
        });
        this.stateMachine.currentMap.foregroundSources.forEach((fgSource) => {
            const fgImage = imageStore.get(fgSource);
            foregroundImages.push(fgImage);
        });

        this.pauseMenu = new PauseMenuUI({ stateMachine: this.stateMachine });
        this.pokedexMenu = new PokedexMenu({ stateMachine: this.stateMachine });
        this.pcMenu = new PCMenu({ stateMachine: this.stateMachine });
        this.martOptionsMenu = new MartOptionsMenu({ stateMachine: this.stateMachine });
        this.martItemsMenu = new MartItemsMenu({ stateMachine: this.stateMachine });
        this.martItemAmountBox = new MartItemAmountBox({
            stateMachine: this.stateMachine,
            position: {
                x: 0,
                y: 40,
            },
        });
        this.trainerCard = new TrainerCard({ stateMachine: this.stateMachine });
        this.pokemonMenu = new PokemonMenu({
            partyPokemon: this.stateMachine.player.party,
            currentOption: this.stateMachine.pokemonOption,
            visible: false,
            position: { x: 0, y: 0 },
            GUI: this,
        });
        this.yesOrNoMenu = new OptionsBox({
            position: { x: 176, y: 64 },
            visible: false,
            options: ['Yes', 'No'],
            selectedOption: 0,
        });
        this.summaryMenu = new PokemonSummary({
            pokemon: null,
            currentPage: 0,
            visible: false,
            position: { x: 0, y: 0 },
        });
        this.newMoveMenu = new NewMoveMenu({
            visible: false,
            position: { x: 0, y: 0 },
            pokemon: this.stateMachine.player.party[this.stateMachine.pokemonOption],
        });
        this.bagMenu = new BagMenu({
            visible: false,
            position: { x: 0, y: 0 },
            items: this.stateMachine.player.items,
            currentPage: this.stateMachine.bagOption,
            stateMachine: this.stateMachine,
        });
        this.darkScreen = new DarkScreen({
            visible: true,
            alpha: 0,
        });
        this.flashScreen = new FlashScreen({ visible: true, alpha: 1 });
        this.locationBanner = new LocationBanner();
        this.townMapMenu = new TownMapMenu();
        this.keyboardMenuUI = new KeyboardMenuUI({});
        this.saveFileMenuUI = new SaveFileMenuUI({});
        this.yesOrNoMenuUI = new YesOrNoMenuUI();
        this.optionsMenuUI = new OptionsMenuUI({ stateMachine: this.stateMachine });
        this.playerGenderMenuUI = new PlayerGenderMenuUI();

        // Initialize time-of-day shader
        this.timeOfDayShader = new TimeOfDayShader();

        // Day/night cycle configuration
        this.cycleDurationMinutes = 1; // Default: 1 minute
        this.minCycleMinutes = 1 / 60; // Minimum: 1 second (for testing/observation)
        this.maxCycleMinutes = 24 * 60; // 24 hours
        this.cycleStartTime = Date.now(); // When the current cycle started
        this.lastUpdateTime = Date.now(); // Last time we updated the shader

        // Shader refresh configuration
        this.shaderUpdateIntervalMs = 10; // Default: update every 1 second (1000ms)
        this.minShaderUpdateIntervalMs = 16; // Minimum: ~60fps (16ms)
        this.maxShaderUpdateIntervalMs = 60000; // Maximum: 1 minute (60000ms)

        this.boundaries = this.stateMachine.currentMap.boundaries;
        this.textSources = this.stateMachine.currentMap.textSources;
        this.battleZones = this.stateMachine.currentMap.battleZones;
        this.waterZones = this.stateMachine.currentMap.waterZones;
        this.pcLocations = this.stateMachine.currentMap.pcLocations;
        this.waterEntryZones = this.stateMachine.currentMap.waterEntryZones;
        this.landEntryZones = this.stateMachine.currentMap.landEntryZones;
        this.downLedges = this.stateMachine.currentMap.downLedges;
        this.leftLedges = this.stateMachine.currentMap.leftLedges;
        this.rightLedges = this.stateMachine.currentMap.rightLedges;
        this.npcs = this.stateMachine.currentMap.npcs;
        this.trainers = this.stateMachine.currentMap.trainers;
        this.overworldItems = this.stateMachine.currentMap.overworldItems;
        this.staticEncounters = this.stateMachine.currentMap.staticEncounters;
        this.starterPokemonPokeballs = this.stateMachine.currentMap.starterPokemonPokeballs;
        this.hmTrees = this.stateMachine.currentMap.hmTrees;
        this.hmRocks = this.stateMachine.currentMap.hmRocks;
        this.warpZones = this.stateMachine.currentMap.warpZones;
        this.teleportLocations = this.stateMachine.currentMap.teleportLocations;
        this.locationIndicatorZones = this.stateMachine.currentMap.locationIndicatorZones;
        this.eventTriggers = this.stateMachine.currentMap.eventTriggers;
        this.verticalPositionControls = this.stateMachine.currentMap.verticalPositionControls;
        this.diagonalMovementControls = this.stateMachine.currentMap.diagonalMovementControls;
        this.flowers = this.stateMachine.currentMap.flowers;
        this.healingLocations = this.stateMachine.currentMap.healingLocations;
        this.martLocations = this.stateMachine.currentMap.martLocations;
        this.playerXOffset = this.stateMachine.player.displayPosition.x - this.stateMachine.player.position.x;
        this.playerYOffset = this.stateMachine.player.displayPosition.y - this.stateMachine.player.position.y;

        this.sprites.backgrounds = backgroundImages.map((bgImg) => {
            return new Sprite({ position: { x: 0, y: 0, z: bgImg.z }, image: bgImg });
        });
        this.sprites.foregrounds = foregroundImages.map((fgImg) => {
            return new Sprite({ position: { x: 0, y: 0, z: fgImg.z }, image: fgImg });
        });

        this.boundaries.forEach((boundary) => (boundary.OSM = this.stateMachine));
        this.textSources.forEach((textSource) => (textSource.OSM = this.stateMachine));
        this.battleZones.forEach((battleZone) => (battleZone.OSM = this.stateMachine));
        this.waterZones.forEach((waterZone) => (waterZone.OSM = this.stateMachine));
        this.pcLocations.forEach((pcLocation) => (pcLocation.OSM = this.stateMachine));
        this.waterEntryZones.forEach((waterEntryZone) => (waterEntryZone.OSM = this.stateMachine));
        this.landEntryZones.forEach((landEntryZone) => (landEntryZone.OSM = this.stateMachine));
        this.downLedges.forEach((downLedge) => (downLedge.OSM = this.stateMachine));
        this.leftLedges.forEach((leftLedge) => (leftLedge.OSM = this.stateMachine));
        this.rightLedges.forEach((rightLedge) => (rightLedge.OSM = this.stateMachine));
        this.npcs.forEach((npc) => (npc.OSM = this.stateMachine));
        this.trainers.forEach((trainer) => (trainer.OSM = this.stateMachine));
        this.overworldItems.forEach((item) => (item.OSM = this.stateMachine));
        this.hmTrees.forEach((tree) => (tree.OSM = this.stateMachine));
        this.hmRocks.forEach((rock) => (rock.OSM = this.stateMachine));
        this.warpZones.forEach((warpZone) => (warpZone.OSM = this.stateMachine));
        this.eventTriggers.forEach((eventTrigger) => (eventTrigger.OSM = this.stateMachine));
        this.teleportLocations.forEach((teleportLocation) => (teleportLocation.OSM = this.stateMachine));
        this.locationIndicatorZones.forEach((liz) => (liz.OSM = this.stateMachine));
        this.verticalPositionControls.forEach((vpc) => (vpc.OSM = this.stateMachine));
        this.diagonalMovementControls.forEach((dmc) => (dmc.OSM = this.stateMachine));
        this.flowers.forEach((flower) => (flower.OSM = this.stateMachine));
        this.healingLocations.forEach((healingLocation) => (healingLocation.OSM = this.stateMachine));
        this.martLocations.forEach((martLocation) => (martLocation.OSM = this.stateMachine));
        this.pokemonPreview = new PokemonPreview({ pokemon: this.stateMachine.player.party[0] });
        this.allDrawableObjects = null;
        this.drawablesV2 = { 0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [], 8: [] };
    }

    refreshOSM() {
        // Get the current OSM instance
        const currentOSM = getOSM();

        // Update stateMachine reference
        this.stateMachine = currentOSM;

        // Update GUI reference in the state machine
        this.stateMachine.GUI = this;

        // Update OSM references in menus that have OSM property
        this.pauseMenu.stateMachine = currentOSM;
        this.pokedexMenu.stateMachine = currentOSM;
        this.pcMenu.stateMachine = currentOSM;
        this.martOptionsMenu.stateMachine = currentOSM;
        this.martItemsMenu.stateMachine = currentOSM;
        this.martItemAmountBox.stateMachine = currentOSM;
        this.trainerCard.stateMachine = currentOSM;
        this.optionsMenuUI.stateMachine = currentOSM;

        // Update map-related arrays with new references from current map
        this.boundaries = this.stateMachine.currentMap.boundaries;
        this.textSources = this.stateMachine.currentMap.textSources;
        this.battleZones = this.stateMachine.currentMap.battleZones;
        this.waterZones = this.stateMachine.currentMap.waterZones;
        this.pcLocations = this.stateMachine.currentMap.pcLocations;
        this.waterEntryZones = this.stateMachine.currentMap.waterEntryZones;
        this.landEntryZones = this.stateMachine.currentMap.landEntryZones;
        this.downLedges = this.stateMachine.currentMap.downLedges;
        this.leftLedges = this.stateMachine.currentMap.leftLedges;
        this.rightLedges = this.stateMachine.currentMap.rightLedges;
        this.npcs = this.stateMachine.currentMap.npcs;
        this.trainers = this.stateMachine.currentMap.trainers;
        this.overworldItems = this.stateMachine.currentMap.overworldItems;
        this.staticEncounters = this.stateMachine.currentMap.staticEncounters;
        this.starterPokemonPokeballs = this.stateMachine.currentMap.starterPokemonPokeballs;
        this.hmTrees = this.stateMachine.currentMap.hmTrees;
        this.hmRocks = this.stateMachine.currentMap.hmRocks;
        this.warpZones = this.stateMachine.currentMap.warpZones;
        this.locationIndicatorZones = this.stateMachine.currentMap.locationIndicatorZones;
        this.eventTriggers = this.stateMachine.currentMap.eventTriggers;
        this.teleportLocations = this.stateMachine.currentMap.teleportLocations;
        this.verticalPositionControls = this.stateMachine.currentMap.verticalPositionControls;
        this.diagonalMovementControls = this.stateMachine.currentMap.diagonalMovementControls;
        this.flowers = this.stateMachine.currentMap.flowers;
        this.healingLocations = this.stateMachine.currentMap.healingLocations;
        this.martLocations = this.stateMachine.currentMap.martLocations;

        // Reassign OSM to all map objects
        this.boundaries.forEach((boundary) => (boundary.OSM = currentOSM));
        this.textSources.forEach((textSource) => (textSource.OSM = currentOSM));
        this.battleZones.forEach((battleZone) => (battleZone.OSM = currentOSM));
        this.waterZones.forEach((waterZone) => (waterZone.OSM = currentOSM));
        this.pcLocations.forEach((pcLocation) => (pcLocation.OSM = currentOSM));
        this.waterEntryZones.forEach((waterEntryZone) => (waterEntryZone.OSM = currentOSM));
        this.landEntryZones.forEach((landEntryZone) => (landEntryZone.OSM = currentOSM));
        this.downLedges.forEach((downLedge) => (downLedge.OSM = currentOSM));
        this.leftLedges.forEach((leftLedge) => (leftLedge.OSM = currentOSM));
        this.rightLedges.forEach((rightLedge) => (rightLedge.OSM = currentOSM));
        this.npcs.forEach((npc) => (npc.OSM = currentOSM));
        this.trainers.forEach((trainer) => (trainer.OSM = currentOSM));
        this.overworldItems.forEach((item) => (item.OSM = currentOSM));
        this.staticEncounters.forEach((staticEncounter) => (staticEncounter.OSM = currentOSM));
        this.starterPokemonPokeballs.forEach(
            (starterPokemonPokeball) => (starterPokemonPokeball.OSM = currentOSM)
        );
        this.hmTrees.forEach((tree) => (tree.OSM = currentOSM));
        this.hmRocks.forEach((rock) => (rock.OSM = currentOSM));
        this.warpZones.forEach((warpZone) => (warpZone.OSM = currentOSM));
        this.eventTriggers.forEach((eventTrigger) => (eventTrigger.OSM = currentOSM));
        this.teleportLocations.forEach((teleportLocation) => (teleportLocation.OSM = currentOSM));
        this.locationIndicatorZones.forEach((liz) => (liz.OSM = currentOSM));
        this.verticalPositionControls.forEach((vpc) => (vpc.OSM = currentOSM));
        this.diagonalMovementControls.forEach((dmc) => (dmc.OSM = currentOSM));
        this.flowers.forEach((flower) => (flower.OSM = currentOSM));
        this.healingLocations.forEach((healingLocation) => (healingLocation.OSM = currentOSM));
        this.martLocations.forEach((martLocation) => (martLocation.OSM = currentOSM));

        if (this.stateMachine.currentMap.needsFlash && this.stateMachine.currentMap.flashWasAttempted) {
            this.flashScreen.flashRadius = 161;
        }

        this.updateRivalNPCTypes();

        // Update player sprite reference
        this.sprites.player = this.stateMachine.player.overworldSprite;

        // Update pokemon menu with current party
        this.pokemonMenu.partyPokemon = this.stateMachine.player.party;
        this.pokemonMenu.currentOption = this.stateMachine.pokemonOption;

        // Update bag menu with current items
        this.bagMenu.items = this.stateMachine.player.items;
        this.bagMenu.currentPage = this.stateMachine.bagOption;

        // Update new move menu with current pokemon
        this.newMoveMenu.pokemon = this.stateMachine.player.party[this.stateMachine.pokemonOption];
        const backgroundImages = [];
        const foregroundImages = [];
        this.stateMachine.currentMap.backgroundSources.forEach((bgSource) => {
            const bgImage = imageStore.get(bgSource);
            backgroundImages.push(bgImage);
        });
        this.stateMachine.currentMap.foregroundSources.forEach((fgSource) => {
            const fgImage = imageStore.get(fgSource);
            foregroundImages.push(fgImage);
        });

        this.sprites.backgrounds = backgroundImages.map((bgImg) => {
            return new Sprite({ position: { x: 0, y: 0, z: bgImg.z }, image: bgImg });
        });
        this.sprites.foregrounds = foregroundImages.map((fgImg) => {
            return new Sprite({ position: { x: 0, y: 0, z: fgImg.z }, image: fgImg });
        });
        this.cacheDrawableObjects();
    }

    darken(rate = 0.1) {
        if (this.darkScreen.alpha < 1) {
            this.darkScreen.alpha += rate;
        } else {
            this.darkScreen.alpha = 1;
        }
        return this.darkScreen.alpha === 1;
    }

    undarken(rate = 0.1) {
        if (this.darkScreen.alpha > 0) {
            this.darkScreen.alpha -= rate;
        } else {
            this.darkScreen.alpha = 0;
        }
        return this.darkScreen.alpha === 0;
    }

    useFlash() {
        this.flashScreen.flashRadius += 1;
        return this.flashScreen.flashRadius > 160;
    }

    setup() {
        const backgroundImages = [];
        const foregroundImages = [];
        this.stateMachine.currentMap.backgroundSources.forEach((bgSource) => {
            const bgImage = imageStore.get(bgSource);
            backgroundImages.push(bgImage);
        });

        this.stateMachine.currentMap.foregroundSources.forEach((fgSource) => {
            const fgImage = imageStore.get(fgSource);
            foregroundImages.push(fgImage);
        });

        this.boundaries = this.stateMachine.currentMap.boundaries;
        this.textSources = this.stateMachine.currentMap.textSources;
        this.battleZones = this.stateMachine.currentMap.battleZones;
        this.waterZones = this.stateMachine.currentMap.waterZones;
        this.pcLocations = this.stateMachine.currentMap.pcLocations;
        this.waterEntryZones = this.stateMachine.currentMap.waterEntryZones;
        this.landEntryZones = this.stateMachine.currentMap.landEntryZones;
        this.downLedges = this.stateMachine.currentMap.downLedges;
        this.leftLedges = this.stateMachine.currentMap.leftLedges;
        this.rightLedges = this.stateMachine.currentMap.rightLedges;
        this.npcs = this.stateMachine.currentMap.npcs;
        this.trainers = this.stateMachine.currentMap.trainers;
        this.overworldItems = this.stateMachine.currentMap.overworldItems;
        this.staticEncounters = this.stateMachine.currentMap.staticEncounters;
        this.starterPokemonPokeballs = this.stateMachine.currentMap.starterPokemonPokeballs;
        this.hmTrees = this.stateMachine.currentMap.hmTrees;
        this.hmRocks = this.stateMachine.currentMap.hmRocks;
        this.warpZones = this.stateMachine.currentMap.warpZones;
        this.locationIndicatorZones = this.stateMachine.currentMap.locationIndicatorZones;
        this.eventTriggers = this.stateMachine.currentMap.eventTriggers;
        this.teleportLocations = this.stateMachine.currentMap.teleportLocations;
        this.verticalPositionControls = this.stateMachine.currentMap.verticalPositionControls;
        this.diagonalMovementControls = this.stateMachine.currentMap.diagonalMovementControls;
        this.flowers = this.stateMachine.currentMap.flowers;
        this.healingLocations = this.stateMachine.currentMap.healingLocations;
        this.martLocations = this.stateMachine.currentMap.martLocations;
        this.playerXOffset = this.stateMachine.player.displayPosition.x - this.stateMachine.player.position.x;
        this.playerYOffset = this.stateMachine.player.displayPosition.y - this.stateMachine.player.position.y;
        this.sprites.backgrounds = backgroundImages.map((bgImg) => {
            return new Sprite({ position: { x: 0, y: 0, z: bgImg.z }, image: bgImg });
        });
        this.sprites.foregrounds = foregroundImages.map((fgImg) => {
            return new Sprite({ position: { x: 0, y: 0, z: fgImg.z }, image: fgImg });
        });

        this.boundaries.forEach((boundary) => (boundary.OSM = this.stateMachine));
        this.textSources.forEach((textSource) => (textSource.OSM = this.stateMachine));
        this.battleZones.forEach((battleZone) => (battleZone.OSM = this.stateMachine));
        this.waterZones.forEach((waterZone) => (waterZone.OSM = this.stateMachine));
        this.pcLocations.forEach((pcLocation) => (pcLocation.OSM = this.stateMachine));
        this.waterEntryZones.forEach((waterEntryZone) => (waterEntryZone.OSM = this.stateMachine));
        this.landEntryZones.forEach((landEntryZone) => (landEntryZone.OSM = this.stateMachine));
        this.downLedges.forEach((downLedge) => (downLedge.OSM = this.stateMachine));
        this.leftLedges.forEach((leftLedge) => (leftLedge.OSM = this.stateMachine));
        this.rightLedges.forEach((rightLedge) => (rightLedge.OSM = this.stateMachine));
        this.npcs.forEach((npc) => (npc.OSM = this.stateMachine));
        this.trainers.forEach((trainer) => (trainer.OSM = this.stateMachine));
        this.overworldItems.forEach((item) => (item.OSM = this.stateMachine));
        this.staticEncounters.forEach((staticEncounter) => (staticEncounter.OSM = this.stateMachine));
        this.starterPokemonPokeballs.forEach(
            (starterPokemonPokeball) => (starterPokemonPokeball.OSM = this.stateMachine)
        );
        this.hmTrees.forEach((tree) => (tree.OSM = this.stateMachine));
        this.hmRocks.forEach((rock) => (rock.OSM = this.stateMachine));
        this.warpZones.forEach((warpZone) => (warpZone.OSM = this.stateMachine));
        this.locationIndicatorZones.forEach((liz) => (liz.OSM = this.stateMachine));
        this.eventTriggers.forEach((et) => (et.OSM = this.stateMachine));
        this.teleportLocations.forEach((teleportLocation) => (teleportLocation.OSM = this.stateMachine));
        this.verticalPositionControls.forEach((vpc) => (vpc.OSM = this.stateMachine));
        this.diagonalMovementControls.forEach((dmc) => (dmc.OSM = this.stateMachine));
        this.healingLocations.forEach((healingLocation) => (healingLocation.OSM = this.stateMachine));
        this.martLocations.forEach((martLocation) => (martLocation.OSM = this.stateMachine));
        this.flashScreen.flashRadius = 24;
        this.updateRivalNPCTypes();
        this.cacheDrawableObjects();
        console.log('setting up');
    }

    updateRivalNPCTypes() {
        const player = this.stateMachine.player;
        if (!player?.gender) return;
        const rivalType = player.gender === 'boy' ? 'rival_girl' : 'rival_boy';
        const allNPCs = [
            ...this.stateMachine.currentMap.npcs,
            ...this.stateMachine.currentMap.trainers,
        ];
        for (const npc of allNPCs) {
            if (npc.type === 'rival' || npc.type === 'rival_boy' || npc.type === 'rival_girl') {
                npc.setType(rivalType);
            }
        }
    }

    cacheDrawableObjects() {
        // Pre-compute the array of all drawable objects
        this.allDrawableObjects = [
            // ...this.boundaries,
            ...this.textSources,
            ...this.flowers,
            ...this.battleZones,
            ...this.waterZones,
            ...this.pcLocations,
            // ...this.downLedges,
            // ...this.leftLedges,
            // ...this.rightLedges,
            ...this.npcs,
            ...this.npcs.map((npc) => npc.exclamationMark),
            ...this.trainers,
            ...this.trainers.map((t) => t.exclamationMark),
            ...this.overworldItems,
            ...this.staticEncounters,
            ...this.starterPokemonPokeballs,
            ...this.hmTrees,
            ...this.hmRocks,
            // ...this.warpZones,
            // ...this.verticalPositionControls,
            // ...this.diagonalMovementControls,
            ...this.healingLocations,
            ...this.martLocations,
            ...this.eventTriggers,
            ...this.teleportLocations,
            ...this.locationIndicatorZones,
        ];
    }

    makeDrawable(obj) {
        const z = obj.position.z;
        if (z === undefined || z === null) {
            console.warn(`Object missing z index:`, obj);
            return;
        }
        this.drawablesV2[z].push(obj);
    }

    drawV2() {
        if (this.allDrawableObjects === null) {
            this.cacheDrawableObjects();
        }
        this.stateMachine.player.updateOverworldSprite();
        this.sprites.player = this.stateMachine.player.overworldSprite;

        for (let i = 0; i <= 8; i++) {
            this.drawablesV2[i] = [];
        }
        const drawableObjectsInView = this.allDrawableObjects.filter((d) => {
            const playerPosition = this.stateMachine.player.position;

            const c1 = Math.abs(d.position.x - playerPosition.x) < 128 + 32;
            const c2 = Math.abs(d.position.y - playerPosition.y) < 100;

            if (d.debugDraw) {
                // debugger;
            }

            return c1 && c2;
        });

        for (const obj of drawableObjectsInView) {
            this.makeDrawable(obj);
        }

        this.p1 = performance.now();
        this.layerRenderCount = 0;
        try {
            this.drawablesV2[this.stateMachine.player.position.z].unshift(this.sprites.player);
            this.drawablesV2[this.stateMachine.player.position.z].unshift(this.sprites.playerShadow);
        } catch (error) {
            console.error('Player z-index error:', error.message);
            console.log('Player z:', this.stateMachine.player.position.z);
        }

        // Render backgrounds + foregrounds
        for (const [zIndex, drawables] of Object.entries(this.drawablesV2)) {
            this.renderLayer(parseInt(zIndex), drawables);
        }

        // Update day/night cycle (updates every second)
        this.updateDayNightCycle();

        this.timeOfDayShader.apply();

        // Render UI
        this.drawUI();

        this.p2 = performance.now();
        this.performance = Math.round(this.p2 - this.p1);
    }

    renderLayer(zIndex, drawables) {
        this.playerXOffset = this.stateMachine.player.displayPosition.x - this.stateMachine.player.position.x;
        this.playerYOffset = this.stateMachine.player.displayPosition.y - this.stateMachine.player.position.y;
        const bgXOffset = this.stateMachine.player.position.x - this.stateMachine.player.displayPosition.x;
        const bgYOffset = this.stateMachine.player.position.y - this.stateMachine.player.displayPosition.y;
        // Draw background for this layer
        const bgLayer = this.sprites.backgrounds[zIndex];
        const frameWidth = 0;
        if (bgLayer) {
            bgLayer.position.x = 0;
            bgLayer.position.y = 0;
            bgLayer.destinationX = frameWidth;
            bgLayer.destinationY = frameWidth;
            bgLayer.sourceX = bgXOffset + frameWidth;
            bgLayer.sourceY = bgYOffset + frameWidth;
            bgLayer.width = 240 - frameWidth * 2;
            bgLayer.height = 160 - frameWidth * 2;
            bgLayer.drawBackground();
        }

        drawables.sort((a, b) => {
            const dy = a.position.y - b.position.y;
            if (dy !== 0) return dy;
            return (a instanceof NPCShadow ? 0 : 1) - (b instanceof NPCShadow ? 0 : 1);
        });

        drawables.forEach((drawable) => {
            this.layerRenderCount += 1;
            drawable.draw();
        });

        // Draw player's head above everything else in the same z index
        if (zIndex === this.stateMachine.player.position.z) {
            this.sprites.player.drawTopPortion(this.stateMachine.player.biking ? 24 : 18);
        }

        // Draw foreground for this layer
        const fgLayer = this.sprites.foregrounds[zIndex];
        if (fgLayer) {
            fgLayer.position.x = 0;
            fgLayer.position.y = 0;
            fgLayer.destinationX = frameWidth;
            fgLayer.destinationY = frameWidth;
            fgLayer.sourceX = bgXOffset + frameWidth;
            fgLayer.sourceY = bgYOffset + frameWidth;
            fgLayer.width = 240 - frameWidth * 2;
            fgLayer.height = 160 - frameWidth * 2;
            fgLayer.drawBackground();
        }
    }

    drawUI() {
        this.sprites.introBackground.draw();
        this.sprites.introCreditsBackground.draw();
        if (this.stateMachine.currentMap.needsFlash) {
            this.flashScreen.draw();
        }

        this.pauseMenu.draw();
        this.trainerCard.draw();
        this.bagMenu.draw();
        this.pokemonMenu.draw();
        this.summaryMenu.draw();
        this.pcMenu.draw();

        this.sprites.overworldTextBox.visible = this.stateMachine.overworldText.length > 0;
        this.speakerLabel.visible = this.sprites.overworldTextBox.visible && this.stateMachine.overworldTextSpeaker.length > 0;

        this.martOptionsMenu.draw();
        this.martItemsMenu.draw();
        this.martItemAmountBox.draw();
        this.pokedexMenu.draw();
        this.townMapMenu.draw();
        this.yesOrNoMenu.draw();
        this.newMoveMenu.draw();
        // this.fpsText.draw();
        this.locationBanner.draw();
        this.keyboardMenuUI.draw();
        this.saveFileMenuUI.draw();
        this.speakerLabel.draw();
        this.sprites.overworldTextBox.draw();
        this.overworldText.draw();
        this.playerGenderMenuUI.draw();
        this.yesOrNoMenuUI.draw();
        this.optionsMenuUI.draw();
        this.darkScreen.draw();
        this.pokemonPreview.draw();
        this._drawDebugHighlight();
    }

    _initDebugClickListener() {
        if (!import.meta.env.DEV) return;

        canvas.addEventListener('click', (e) => {

            const rect = canvas.getBoundingClientRect();
            const scaleX = canvas.width / rect.width;
            const scaleY = canvas.height / rect.height;
            const canvasX = (e.clientX - rect.left) * scaleX;
            const canvasY = (e.clientY - rect.top) * scaleY;

            const player = this.stateMachine.player;
            const worldX = canvasX + (player.position.x - player.displayPosition.x);
            const worldY = canvasY + (player.position.y - player.displayPosition.y);

            const gridX = Math.floor(worldX / 16) * 16;
            const gridY = Math.floor(worldY / 16) * 16;

            this.debugHighlight = { gridX, gridY, framesLeft: 60 };
            console.log(`[DEBUG] Grid click — world: (${gridX}, ${gridY})  grid: (${gridX / 16}, ${gridY / 16})  z: ${player.position.z}`);

            const map = this.stateMachine.currentMap;
            const allObjects = [
                ...map.boundaries,
                ...map.npcs,
                ...map.trainers,
                ...(map.textSources || []),
                ...(map.battleZones || []),
                ...(map.waterZones || []),
                ...(map.overworldItems || []),
                ...(map.staticEncounters || []),
                ...(map.eventTriggers || []),
                ...(map.warpZones || []),
                ...(map.teleportLocations || []),
                ...(map.hmTrees || []),
                ...(map.hmRocks || []),
                ...(map.healingLocations || []),
                ...(map.martLocations || []),
                player,
            ];
            const matches = allObjects.filter((obj) => {
                const ox = Math.floor(obj.position.x / 16) * 16;
                const oy = Math.floor(obj.position.y / 16) * 16;
                return ox === gridX && oy === gridY;
            });
            if (matches.length > 0) {
                console.log(`[DEBUG] Objects at (${gridX}, ${gridY}):`);
                matches.forEach((obj) => {
                    const type = obj.constructor?.name || 'Unknown';
                    const id = obj.identifier || obj.name || obj.id || '';
                    console.log(`  z=${obj.position.z}  ${type}${id ? ` (${id})` : ''}`, obj);
                });
            } else {
                console.log(`[DEBUG] No objects at (${gridX}, ${gridY})`);
            }
        });
    }

    _drawDebugHighlight() {
        if (!this.debugHighlight) return;

        const h = this.debugHighlight;
        if (h.framesLeft <= 0) {
            this.debugHighlight = null;
            return;
        }

        const player = this.stateMachine.player;
        const screenX = h.gridX - (player.position.x - player.displayPosition.x);
        const screenY = h.gridY - (player.position.y - player.displayPosition.y);

        const alpha = Math.min(1, h.framesLeft / 15);
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.strokeStyle = 'red';
        ctx.lineWidth = 1;
        ctx.strokeRect(screenX + 0.5, screenY + 0.5, 15, 15);
        ctx.fillStyle = 'rgba(255, 0, 0, 0.25)';
        ctx.fillRect(screenX, screenY, 16, 16);
        ctx.restore();

        h.framesLeft--;
    }

    // Helper methods for different state groups
    handlePokemonMenuStates() {
        this.handleYesOrNoMenu();
        this.pokemonMenu.visible = true;
        this.pokemonMenu.partyPokemon = this.stateMachine.player.party;
        this.pokemonMenu.sprites.pokemonOptionsBox.visible = false;
        this.pokemonMenu.sprites.pokemonItemOptionsBox.visible = false;
        this.pokemonMenu.currentOption = this.stateMachine.pokemonOption;

        if (this.stateMachine.currentState === POKEMON_PRESELECTED) {
            this.pokemonMenu.sprites.pokemonOptionsBox.visible = true;
            this.pokemonMenu.sprites.pokemonOptionsBox.selectedOption = this.stateMachine.pokemonDetailOption;
        }

        if (this.stateMachine.currentState === DO_WHAT_WITH_ITEM) {
            this.pokemonMenu.sprites.pokemonItemOptionsBox.visible = true;
            this.pokemonMenu.sprites.pokemonItemOptionsBox.selectedOption =
                this.stateMachine.pokemonItemOption;
        } else {
            this.pokemonMenu.sprites.pokemonItemOptionsBox.visible = false;
        }

        if (this.stateMachine.currentState === SELECT_ITEM_CONSUMER_MOVE) {
            this.pokemonMenu.sprites.moveOptionsBox.visible = true;
            this.pokemonMenu.sprites.moveOptionsBox.selectedOption = this.stateMachine.moveItemOption;
        } else {
            this.pokemonMenu.sprites.moveOptionsBox.visible = false;
            this.pokemonMenu.sprites.moveOptionsBox.selectedOption = 0;
        }

        if (this.stateMachine.currentState === SWITCH_POSITIONS_WITH_WHO) {
            this.pokemonMenu.sprites.pokemonOptionsBox.visible = false;
            this.pokemonMenu.sprites.pokemonOptionsBox.selectedOption = 0;
            this.pokemonMenu.helpText.text = `Switch ${
                this.pokemonMenu.getCurrentPokemonBySwitchIndex()?.name
            } with who?`;
        } else {
            this.pokemonMenu.helpText.text = 'Choose a pokemon.';
        }

        if (this.stateMachine.currentState === ITEM_GIVEN_TO_POKEMON) {
            this.pokemonMenu.sprites.pokemonItemOptionsBox.visible = false; // TODO: Check
        }

        if (
            [
                IT_WONT_HAVE_ANY_EFFECT,
                APPLY_HM_TO_RECIPIENT,
                CONFIRM_LEARN_NEW_MOVE,
                STOP_LEARNING_NEW_MOVE,
                DID_NOT_LEARN_NEW_MOVE,
                NEW_MOVE_AVAILABLE,
            ].includes(this.stateMachine.currentState)
        ) {
            this.pokemonMenu.shouldShowMoveLearnability =
                this.stateMachine.context.currentMove !== null &&
                this.stateMachine.context.currentMove !== undefined &&
                this.stateMachine.context.learnedMoveSource === 'HM';
        }
    }

    handleSummaryMenuStates() {
        this.handleYesOrNoMenu();
        this.summaryMenu.visible = true;
        // this.summaryMenu.pokemon = this.stateMachine.player.party[this.stateMachine.pokemonOption];
        if (!this.stateMachine.currentSummaryPokemon) {
            return;
        }
        this.summaryMenu.pokemon = this.stateMachine.currentSummaryPokemon;
        this.summaryMenu.currentPage = this.stateMachine.summaryOption;

        if (this.stateMachine.currentState === POKEMON_MOVE_DETAIL) {
            this.summaryMenu.showMoveSummary = true;
            this.summaryMenu.selectedMove = this.stateMachine.moveDetailOption;
        } else {
            this.summaryMenu.showMoveSummary = false;
            this.summaryMenu.selectedMove = 0;
        }
    }

    handleMartBuyStates() {
        this.sprites.player.moving = false;
        this.sprites.player.frames.val = 0;
        this.martItemsMenu.visible = true;
        this.martItemsMenu.currentItem = this.stateMachine.martItemOption;

        if ([MART_OPTION_SELECT_AMOUNT, MART_SELL_AMOUNT].includes(this.stateMachine.currentState)) {
            const currentItem = this.stateMachine.currentMartInventory[this.stateMachine.martItemOption];
            this.martItemAmountBox.visible = true;
            this.martItemAmountBox.amount = this.stateMachine.martItemAmount;
            this.martItemAmountBox.costPerItem = currentItem.cost;
        } else {
            this.martItemAmountBox.visible = false;
        }
        if ([MART_ITEM_AMOUNT_SELECTED].includes(this.stateMachine.currentState)) {
            this.handleYesOrNoMenu();
        }
    }

    handleBagStates() {
        this.bagMenu.stateMachine = this.stateMachine;
        this.bagMenu.visible = true;

        if ([MART_SELL_AMOUNT, MART_SELL_AMOUNT_CONFIRMATION].includes(this.stateMachine.currentState)) {
            this.martItemAmountBox.visible = true;
            this.martItemAmountBox.amount = this.stateMachine.martItemAmount;
            this.martItemAmountBox.costPerItem = Math.round(this.stateMachine.selectedItem.price * 0.5);
            this.handleYesOrNoMenu();
        }

        this.handleBagHMStates();
        this.handleBagItemDetails();
    }

    handleBagHMStates() {
        const isHMState = [
            SELECT_ITEM_CONSUMER,
            APPLY_ITEM_TO_RECIPIENT,
            APPLY_HM_TO_RECIPIENT,
            CONFIRM_LEARN_NEW_MOVE,
            STOP_LEARNING_NEW_MOVE,
            DID_NOT_LEARN_NEW_MOVE,
        ].includes(this.stateMachine.currentState);

        if (isHMState) {
            const currentItem = this.stateMachine.selectedItem.id;
            this.pokemonMenu.shouldShowMoveLearnability = [
                'hm1',
                'hm2',
                'hm3',
                'hm4',
                'hm5',
                'hm6',
                'hm7',
                'hm8',
                'hm9',
                'hm10',
            ].includes(currentItem);
        } else {
            this.pokemonMenu.shouldShowMoveLearnability = false;
        }
    }

    handleBagItemDetails() {
        const showingItemDetails = [
            BAG_ITEM_PRESELECTED,
            KEY_ITEM_PRESELECTED,
            SELECT_ITEM_CONSUMER,
            SELECT_ITEM_RECIPIENT,
            ITEM_GIVEN_TO_POKEMON,
            ITEM_TAKEN_FROM_POKEMON,
            APPLY_ITEM_TO_RECIPIENT,
            APPLY_EV_ITEM_TO_RECIPIENT,
            CONFIRM_LEARN_NEW_MOVE,
            FORGOT_MOVE,
            LEARNED_NEW_MOVE,
            HEALTH_ITEM_APPLIED,
            EV_ITEM_APPLIED,
            MOVE_ITEM_APPLIED,
            APPLY_ITEM_TO_MOVE,
        ].includes(this.stateMachine.currentState);

        if (showingItemDetails) {
            const showingPokemonMenu = [
                SELECT_ITEM_CONSUMER,
                SELECT_ITEM_RECIPIENT,
                APPLY_ITEM_TO_RECIPIENT,
                APPLY_EV_ITEM_TO_RECIPIENT,
                ITEM_GIVEN_TO_POKEMON,
                ITEM_TAKEN_FROM_POKEMON,
                CONFIRM_LEARN_NEW_MOVE,
                STOP_LEARNING_NEW_MOVE,
                DID_NOT_LEARN_NEW_MOVE,
                FORGOT_MOVE,
                LEARNED_NEW_MOVE,
                HEALTH_ITEM_APPLIED,
                EV_ITEM_APPLIED,
                APPLY_EV_ITEM_TO_RECIPIENT,
                MOVE_ITEM_APPLIED,
                APPLY_ITEM_TO_MOVE,
            ].includes(this.stateMachine.currentState);

            if (showingPokemonMenu) {
                this.pokemonMenu.visible = true;
                this.pokemonMenu.currentOption = this.stateMachine.pokemonOption;
                this.bagMenu.sprites.bagOptionsBox.visible = false;
            } else {
                this.bagMenu.sprites.bagOptionsBox.setOptions(
                    this.stateMachine?.selectedItem?.overworldOptions ?? ['Use', 'Cancel']
                );
                this.bagMenu.sprites.bagOptionsBox.visible = true;

                this.bagMenu.sprites.bagOptionsBox.selectedOption = this.stateMachine.bagItemDetailOption;
                this.pokemonMenu.visible = false;
            }
        } else {
            this.bagMenu.sprites.bagOptionsBox.visible = false;
            this.bagMenu.sprites.bagOptionsBox.selectedOption = 0;
        }
    }

    handleMoveForgetState() {
        this.newMoveMenu.pokemon = this.stateMachine.player.party[this.stateMachine.pokemonOption];
        this.newMoveMenu.visible = true;
        this.newMoveMenu.selectedMove = this.stateMachine.summaryMoveDetailOption;
        this.newMoveMenu.newMove = this.stateMachine.selectedItem.move;
    }

    handleMartOptionState() {
        this.sprites.player.moving = false;
        this.sprites.player.frames.val = 0;
        this.martOptionsMenu.visible = true;
        this.martOptionsMenu.currentOption = this.stateMachine.martMenuOption;
    }

    handlePokedexState() {
        this.sprites.player.moving = false;
        this.sprites.player.frames.val = 0;
        this.pokedexMenu.visible = true;
        this.pokedexMenu.currentOption = this.stateMachine.pokedexMenuOption;
    }

    handlePCMenuState() {
        this.sprites.player.moving = false;
        this.sprites.player.frames.val = 0;
        this.pcMenu.visible = true;
    }

    handleYesOrNoMenu() {
        this.yesOrNoMenuUI.menu = getOSM().yesOrNoMenu;
        if (getOSM().yesOrNoMenu.position) {
            this.yesOrNoMenuUI.position = getOSM().yesOrNoMenu.position;
        } else {
            this.yesOrNoMenuUI.position = { x: 176, y: 64 };
        }
        if (this.stateMachine.isAskingYesOrNo) {
            this.yesOrNoMenu.visible = true;
            this.yesOrNoMenu.selectedOption = this.stateMachine.yesOrNoOption;
        } else {
            this.yesOrNoMenu.visible = false;
        }
    }

    handleWaterEntryZoneInteractions() {
        if (this.stateMachine.player.surfing) {
            return;
        }
        if (
            this.stateMachine.adjacentObjects.down instanceof WaterEntryZone &&
            this.stateMachine.player.direction === DOWN &&
            (keys.s.pressed || keys.S.pressed) &&
            !this.stateMachine.alignedToGrid()
        ) {
            this.sprites.player.jump(1, 2);
        }

        if (
            this.stateMachine.adjacentObjects.left instanceof WaterEntryZone &&
            this.stateMachine.player.direction === LEFT &&
            (keys.a.pressed || keys.A.pressed) &&
            !this.stateMachine.alignedToGrid()
        ) {
            this.sprites.player.jump(1, 2);
        }

        if (
            this.stateMachine.adjacentObjects.right instanceof WaterEntryZone &&
            this.stateMachine.player.direction === RIGHT &&
            (keys.d.pressed || keys.D.pressed) &&
            !this.stateMachine.alignedToGrid()
        ) {
            this.sprites.player.jump(1, 2);
        }

        if (
            this.stateMachine.adjacentObjects.up instanceof WaterEntryZone &&
            this.stateMachine.player.direction === UP &&
            (keys.w.pressed || keys.W.pressed) &&
            !this.stateMachine.alignedToGrid()
        ) {
            this.sprites.player.jump(1, 2);
        }
    }

    handleLandEntryZoneInteractions() {
        if (!this.stateMachine.player.surfing) {
            return;
        }
        if (
            this.stateMachine.adjacentObjects.down instanceof LandEntryZone &&
            this.stateMachine.player.direction === DOWN &&
            (keys.s.pressed || keys.S.pressed) &&
            !this.stateMachine.alignedToGrid()
        ) {
            this.sprites.player.jump(1, 2);
        }

        if (
            this.stateMachine.adjacentObjects.left instanceof LandEntryZone &&
            this.stateMachine.player.direction === LEFT &&
            (keys.a.pressed || keys.A.pressed) &&
            !this.stateMachine.alignedToGrid()
        ) {
            this.sprites.player.jump(1, 2);
        }

        if (
            this.stateMachine.adjacentObjects.right instanceof LandEntryZone &&
            this.stateMachine.player.direction === RIGHT &&
            (keys.d.pressed || keys.D.pressed) &&
            !this.stateMachine.alignedToGrid()
        ) {
            this.sprites.player.jump(1, 2);
        }

        if (
            this.stateMachine.adjacentObjects.up instanceof LandEntryZone &&
            this.stateMachine.player.direction === UP &&
            (keys.w.pressed || keys.W.pressed) &&
            !this.stateMachine.alignedToGrid()
        ) {
            this.sprites.player.jump(1, 2);
        }
    }

    /**
     * Set the time of day for the shader effect.
     * The shader will automatically apply color tinting to simulate different times of day.
     *
     * Example usage:
     *   GUI.setTimeOfDay('day');   // Normal colors
     *   GUI.setTimeOfDay('dusk');  // Warm golden/orange tint
     *   GUI.setTimeOfDay('dawn');  // Same as dusk - golden hour vibes
     *   GUI.setTimeOfDay('night'); // Cool blue tint, darker
     *
     * @param {string} timeOfDay - 'day' | 'dusk' | 'night' | 'dawn'
     */
    setTimeOfDay(timeOfDay) {
        this.timeOfDayShader.setTimeOfDay(timeOfDay);
    }

    /**
     * Get the current time of day setting
     * @returns {string} - 'day' | 'dusk' | 'night' | 'dawn'
     */
    getTimeOfDay() {
        return this.timeOfDayShader.getTimeOfDay();
    }

    /**
     * Set the day/night cycle duration in minutes
     * @param {number} minutes - Cycle duration (will be clamped between minCycleMinutes and maxCycleMinutes)
     */
    setCycleDuration(minutes) {
        this.cycleDurationMinutes = Math.max(this.minCycleMinutes, Math.min(this.maxCycleMinutes, minutes));
        // Reset cycle to start from beginning
        this.cycleStartTime = Date.now();
    }

    /**
     * Get the current cycle duration in minutes
     * @returns {number}
     */
    getCycleDuration() {
        return this.cycleDurationMinutes;
    }

    /**
     * Set the shader update interval in milliseconds
     * @param {number} milliseconds - Update interval (will be clamped between minShaderUpdateIntervalMs and maxShaderUpdateIntervalMs)
     */
    setShaderUpdateInterval(milliseconds) {
        this.shaderUpdateIntervalMs = Math.max(
            this.minShaderUpdateIntervalMs,
            Math.min(this.maxShaderUpdateIntervalMs, milliseconds)
        );
    }

    /**
     * Get the current shader update interval in milliseconds
     * @returns {number}
     */
    getShaderUpdateInterval() {
        return this.shaderUpdateIntervalMs;
    }

    /**
     * Toggle to the next time of day in the cycle: day -> dusk -> night -> dawn -> day -> ...
     * (This will reset the automatic cycle)
     */
    toggleTimeOfDay() {
        const currentTime = this.getTimeOfDay();
        const timeCycle = ['day', 'dusk', 'night', 'dawn'];
        const currentIndex = timeCycle.indexOf(currentTime);
        const nextIndex = (currentIndex + 1) % timeCycle.length;
        this.setTimeOfDay(timeCycle[nextIndex]);
        // Reset cycle when manually toggling
        this.cycleStartTime = Date.now();
    }

    /**
     * Update the day/night cycle and interpolate shader values
     * Should be called every frame, but only updates every second
     */
    updateDayNightCycle() {
        const now = Date.now();
        const elapsedSinceLastUpdate = now - this.lastUpdateTime;

        // Only update at the configured interval
        if (elapsedSinceLastUpdate < this.shaderUpdateIntervalMs) {
            return;
        }

        this.lastUpdateTime = now;

        const osm = getOSM();
        const currentMap = osm.getCurrentMap();
        const currentLocation = osm.getCurrentLocation();
        const optionsMenu = osm.optionsMenu;

        // Priority 1: Fixed time of day from map or location (highest priority)
        const fixedTimeOfDay = currentMap.fixedTimeOfDay || currentLocation?.fixedTimeOfDay;
        if (fixedTimeOfDay) {
            const fixedConfig = this.timeOfDayShader.getTimeOfDayConfig(fixedTimeOfDay);
            this.timeOfDayShader.setCustomConfig(fixedConfig);
            return; // Stop the clock - no cycle calculations needed
        }

        // Priority 2: Time of day override from options menu (if not 'variable')
        if (optionsMenu?.timeOfDay && optionsMenu.timeOfDay !== 'variable') {
            const overrideConfig = this.timeOfDayShader.getTimeOfDayConfig(optionsMenu.timeOfDay);
            this.timeOfDayShader.setCustomConfig(overrideConfig);
            return; // Stop the clock - use fixed time from options
        }

        // Priority 3: Normal day/night cycle calculations
        // Get cycle duration from options menu (in seconds) and convert to milliseconds
        const cycleDurationSeconds = optionsMenu?.dayNightCycleDuration ?? 900; // Default 15 minutes (900 seconds)
        const cycleDurationMs = cycleDurationSeconds * 1000; // Convert seconds to milliseconds
        const elapsedInCycle = (now - this.cycleStartTime) % cycleDurationMs;
        const cycleProgress = elapsedInCycle / cycleDurationMs; // 0 to 1

        // Use sinusoidal oscillation: day and night are peaks/troughs
        // sin(0) = 0 → Day (brightest)
        // sin(π/2) = 1 → Dusk (transition)
        // sin(π) = 0 → Night (darkest)
        // sin(3π/2) = -1 → Dawn (transition)
        // Map cycleProgress (0-1) to sine wave (-1 to 1)
        // Using cosine to start at peak (day) when cycleProgress = 0
        const sineValue = Math.cos(cycleProgress * 2 * Math.PI); // -1 to 1

        // Normalize to 0-1 range where:
        // 0 = Night (darkest)
        // 0.5 = Dusk/Dawn (transition)
        // 1 = Day (brightest)
        const normalizedProgress = (sineValue + 1) / 2; // 0 to 1

        // Get reference configurations for each phase
        const dayConfig = this.timeOfDayShader.getTimeOfDayConfig('day');
        const duskConfig = this.timeOfDayShader.getTimeOfDayConfig('dusk');
        const nightConfig = this.timeOfDayShader.getTimeOfDayConfig('night');
        const dawnConfig = this.timeOfDayShader.getTimeOfDayConfig('dawn');

        // Interpolate based on normalized progress
        // 0.0-0.5: Night -> Dusk/Dawn (transition)
        // 0.5-1.0: Dusk/Dawn -> Day (transition)
        let interpolatedConfig;

        if (normalizedProgress <= 0.5) {
            // Night to Dusk/Dawn transition
            // At 0.0: full night, at 0.5: full dusk/dawn
            const t = normalizedProgress * 2; // 0 to 1
            const nightToDusk = {
                tint: {
                    r: nightConfig.tint.r + (duskConfig.tint.r - nightConfig.tint.r) * t,
                    g: nightConfig.tint.g + (duskConfig.tint.g - nightConfig.tint.g) * t,
                    b: nightConfig.tint.b + (duskConfig.tint.b - nightConfig.tint.b) * t,
                },
                brightness: nightConfig.brightness + (duskConfig.brightness - nightConfig.brightness) * t,
                contrast: nightConfig.contrast + (duskConfig.contrast - nightConfig.contrast) * t,
            };

            // Determine if we're closer to dusk or dawn based on sine value
            // Positive sine = dusk side, negative sine = dawn side
            if (sineValue >= 0) {
                // Dusk side
                interpolatedConfig = nightToDusk;
            } else {
                // Dawn side - interpolate night to dawn
                interpolatedConfig = {
                    tint: {
                        r: nightConfig.tint.r + (dawnConfig.tint.r - nightConfig.tint.r) * t,
                        g: nightConfig.tint.g + (dawnConfig.tint.g - nightConfig.tint.g) * t,
                        b: nightConfig.tint.b + (dawnConfig.tint.b - nightConfig.tint.b) * t,
                    },
                    brightness: nightConfig.brightness + (dawnConfig.brightness - nightConfig.brightness) * t,
                    contrast: nightConfig.contrast + (dawnConfig.contrast - nightConfig.contrast) * t,
                };
            }
        } else {
            // Dusk/Dawn to Day transition
            // At 0.5: full dusk/dawn, at 1.0: full day
            const t = (normalizedProgress - 0.5) * 2; // 0 to 1

            // Determine if we're coming from dusk or dawn
            if (sineValue >= 0) {
                // Coming from dusk
                interpolatedConfig = {
                    tint: {
                        r: duskConfig.tint.r + (dayConfig.tint.r - duskConfig.tint.r) * t,
                        g: duskConfig.tint.g + (dayConfig.tint.g - duskConfig.tint.g) * t,
                        b: duskConfig.tint.b + (dayConfig.tint.b - duskConfig.tint.b) * t,
                    },
                    brightness: duskConfig.brightness + (dayConfig.brightness - duskConfig.brightness) * t,
                    contrast: duskConfig.contrast + (dayConfig.contrast - duskConfig.contrast) * t,
                };
            } else {
                // Coming from dawn
                interpolatedConfig = {
                    tint: {
                        r: dawnConfig.tint.r + (dayConfig.tint.r - dawnConfig.tint.r) * t,
                        g: dawnConfig.tint.g + (dayConfig.tint.g - dawnConfig.tint.g) * t,
                        b: dawnConfig.tint.b + (dayConfig.tint.b - dawnConfig.tint.b) * t,
                    },
                    brightness: dawnConfig.brightness + (dayConfig.brightness - dawnConfig.brightness) * t,
                    contrast: dawnConfig.contrast + (dayConfig.contrast - dawnConfig.contrast) * t,
                };
            }
        }

        // Update shader with interpolated values
        this.timeOfDayShader.setCustomConfig(interpolatedConfig);
    }

    resetUIState() {
        // Handle bag menu items
        this.bagMenu.items = this.stateMachine.player.getAvailableItems();
        // Reset menu visibility
        this.pauseMenu.visible = false;
        this.pauseMenu.currentOption = 0;
        this.optionsMenuUI.visible = false;
        this.trainerCard.visible = false;
        this.pokemonMenu.visible = false;
        this.pokemonMenu.sprites.moveOptionsBox.visible = false;
        this.summaryMenu.visible = false;
        this.summaryMenu.currentPage = 0;
        this.martItemsMenu.visible = false;
        this.martItemAmountBox.visible = false;
        this.bagMenu.visible = false;
        this.bagMenu.currentPage = 0;
        this.bagMenu.currentItems = 0;
        this.pokemonMenu.shouldShowMoveLearnability = false;
        this.newMoveMenu.visible = false;
        this.martOptionsMenu.visible = false;
        this.pokedexMenu.visible = false;
        this.townMapMenu.visible = false;
        this.keyboardMenuUI.visible = false;
        this.saveFileMenuUI.visible = false;
        this.playerGenderMenuUI.visible = false;
        this.pcMenu.visible = false;
        this.sprites.introBackground.visible = false;
        this.sprites.introCreditsBackground.visible = false;
    }

    update() {
        // For debug purposes only
        this.fpsText.text = `FPS: ${this.currentFPS} | ${this.performanceSnapshot} | ${this.stateMachine.performanceSnapshot}`;

        if (KPI_P) {
            console.log(this.stateMachine);
            console.log(this.stateMachine.currentState);
            console.log(globalPokemonDataStore);
            console.log(availableMaps);
            // getOSM().movePlayer([{ left: 2 }, { down: 2 }, { right: 2 }, { up: 2 }]);
            // getOSM().stateQueue.push(MOVING);
        }

        if (KPI_E) {
            this.toggleTimeOfDay();
        }

        // Reset all UI elements to default state
        this.resetUIState();

        switch (this.stateMachine.currentState) {
            case INTRO_CREDITS:
                this.sprites.introCreditsBackground.visible = true;
                break;
            case SAVE_FILE_INCOMPATIBLE:
            case NEW_UNAUTHORIZED_SESSION_STARTED:
            case VERIFY_ACCESS_CODE:
            case NEW_FILE_STARTED:
                this.sprites.introBackground.visible = true;
                break;
            case SET_PLAYER_NAME:
            case SET_NICKNAME:
            case SET_ACCESS_CODE:
            case USE_KEYBOARD:
                this.keyboardMenuUI.visible = true;
                break;
            case SELECT_PLAYER_GENDER:
                this.sprites.introBackground.visible = true;
                this.playerGenderMenuUI.visible = true;
                this.playerGenderMenuUI.menu = getOSM().playerGenderMenu;
                break;
            case SAVE_FILE_SELECT:
                this.saveFileMenuUI.visible = true;
                break;
            case MOVING:
                this.handleWaterEntryZoneInteractions();
                this.handleLandEntryZoneInteractions();
                break;
            case CHANGE_DIRECTION:
                this.sprites.player.moving = true;
                this.sprites.player.hold = this.stateMachine.player.running ? 4 : 8;
                this.handleWaterEntryZoneInteractions();
                this.handleLandEntryZoneInteractions();
                break;
            case OVERWORLD_EVENT:
                this.handleYesOrNoMenu();
                this.sprites.player.running = false;
                getOSM().player.running = false;
                break;
            case READ_TEXT_SOURCE:
            case BOOT_UP_PC:
            case SEEN_BY_TRAINER:
            case ACQUIRE_OVERWORLD_ITEM:
            case WARP_TO_LOCATION:
            case EVOLVE_POKEMON:
            case INTERACT_WITH_HEALING_LOCATION:
            case INTERACT_WITH_HM_TREE:
            case INTERACT_WITH_HM_ROCK:
            case USE_FLASH:
                this.handleYesOrNoMenu();
                this.sprites.player.running = false;
                this.sprites.player.moving = false;
                this.sprites.player.frames.val = 0;
                break;

            case START_BATTLE:
            case START_TRAINER_BATTLE:
            case APPROACHED_BY_TRAINER:
            case BATTLE:
            case END_BATTLE:
                this.sprites.player.moving = false;
                this.sprites.player.running = false;
                this.sprites.player.frames.val = 0;
                break;

            case PAUSE_MENU:
                this.handleYesOrNoMenu();
                this.sprites.player.moving = false;
                this.sprites.player.running = false;
                this.sprites.player.frames.val = 0;
                this.pauseMenu.visible = true;
                this.optionsMenuUI.visible = false;
                break;

            case OPTIONS_MENU:
                this.sprites.player.moving = false;
                this.sprites.player.running = false;
                this.sprites.player.frames.val = 0;
                this.pauseMenu.visible = false;
                this.optionsMenuUI.visible = true;
                break;

            case TRAINER_CARD:
                this.trainerCard.visible = true;
                break;

            case POKEMON:
            case POKEMON_PRESELECTED:
            case SWITCH_POSITIONS_WITH_WHO:
            case POKEMON_SWITCH_POSITIONS:
            case APPLY_HM_TO_RECIPIENT:
            case DO_WHAT_WITH_ITEM:
            case ITEM_GIVEN_TO_POKEMON:
            case CONFIRM_LEARN_NEW_MOVE:
            case STOP_LEARNING_NEW_MOVE:
            case DID_NOT_LEARN_NEW_MOVE:
            case IT_WONT_HAVE_ANY_EFFECT:
            case APPLY_RARE_CANDY:
            case RARE_CANDY_APPLIED:
            case SELECT_ITEM_CONSUMER_MOVE:
            case NEW_MOVE_AVAILABLE:
            case LEVEL_UP_POKEMON:
                this.handlePokemonMenuStates();
                break;

            case POKEMON_SUMMARY:
            case POKEMON_MOVE_DETAIL:
                this.handleSummaryMenuStates();
                break;

            case BUY_FROM_MART:
            case MART_OPTION_PRESELECTED:
            case MART_OPTION_SELECT_AMOUNT:
            case MART_ITEM_AMOUNT_SELECTED:
            case MART_ITEM_AMOUNT_CONFIRMED:
                this.handleMartBuyStates();
                break;

            case BAG:
            case BAG_ITEM_PRESELECTED:
            case KEY_ITEM_PRESELECTED:
            case SELECT_ITEM_CONSUMER:
            case SELECT_ITEM_RECIPIENT:
            case ITEM_TAKEN_FROM_POKEMON:
            case APPLY_ITEM_TO_RECIPIENT:
            case APPLY_EV_ITEM_TO_RECIPIENT:
            case FORGOT_MOVE:
            case LEARNED_NEW_MOVE:
            case HEALTH_ITEM_APPLIED:
            case EV_ITEM_APPLIED:
            case MOVE_ITEM_APPLIED:
            case APPLY_ITEM_TO_MOVE:
            case SELL_TO_MART:
            case CANT_SELL_THIS_ITEM:
            case MART_SELL_AMOUNT:
            case MART_SELL_AMOUNT_CONFIRMATION:
            case MART_ITEMS_SOLD:
            case CANT_USE_ITEM:
            case USE_KEY_ITEM:
                this.handleBagStates();
                break;

            case CHOOSE_MOVE_TO_FORGET:
                this.handleMoveForgetState();
                break;

            case INTERACT_WITH_MART_LOCATION:
            case END_MART_INTERACTION:
                this.sprites.player.moving = false;
                this.sprites.player.running = false;
                this.sprites.player.frames.val = 0;
                break;

            case CHOOSE_MART_OPTION:
                this.handleMartOptionState();
                break;

            case POKEDEX:
                this.handlePokedexState();
                break;

            case TOWN_MAP:
                this.sprites.player.moving = false;
                this.sprites.player.frames.val = 0;
                this.townMapMenu.visible = true;
                break;

            case TOWN_MAP_LOCATION_DETAIL:
                this.sprites.player.moving = false;
                this.sprites.player.frames.val = 0;
                this.townMapMenu.visible = true;
                break;

            case MANAGE_POKEMON:
            case MANAGE_POKEMON_WITH_SELECTED:
            case RELEASE_POKEMON:
            case PC_POKEMON_PRESELECTED:
            case CANT_LEAVE_PC_WITHOUT_POKEMON:
            case SHUT_DOWN_PC:
                this.handlePCMenuState();
                break;

            default:
                if (this.stateMachine.player.surfing) {
                    this.sprites.player.moving = true;
                    this.sprites.player.hold = 32;
                } else if (this.stateMachine.awaitMotionInput()) {
                    this.sprites.player.moving = true;
                    this.sprites.player.hold = this.stateMachine.player.running ? 4 : 8;
                } else {
                    this.sprites.player.moving = false;
                    this.sprites.player.frames.val = 0;
                    this.sprites.player.frames.val = 0;
                }
                break;
        }

        this.overworldText.text = this.stateMachine.overworldText;
        this.overworldText.cursor = this.stateMachine.cursor;
        this.speakerLabel.setSpeaker(this.stateMachine.overworldTextSpeaker);
        this.locationBanner.locationText.text = this.stateMachine.currentLocation.name || '';

        this.drawV2();
    }
}
